// 统计
export const statistic = [
  {
    path: '/statistics/pmp-record-user',
    name: 'PmpRecordUser',
    meta: { tag: '客服工单统计' },
    component: () => import('@/pages/statistics/PmpRecordUserPage')
  },
  {
    path: '/statistics/pmp-record-send-user',
    name: 'PmpRecordSendUser',
    meta: { tag: '客服发货统计' },
    component: () => import('@/pages/statistics/PmpRecordSendUserPage')
  },
  {
    path: '/statistics/pmp-record-receive-user',
    name: 'PmpRecordReceiveUser',
    meta: { tag: '客服收货统计' },
    component: () => import('@/pages/statistics/PmpRecordReceiveUserPage')
  },
  {
    path: '/statistics/test-result',
    name: 'TestResult',
    meta: { tag: '检测结果统计' },
    component: () => import('@/pages/statistics/TestResultPage')
  },
  {
    path: '/statistics/pmp-record-check-user',
    name: 'PmpRecordCheckUser',
    meta: { tag: '客服检测统计' },
    component: () => import('@/pages/statistics/PmpRecordCheckUserPage')
  },
  {
    path: '/statistics/user-month',
    name: 'UserMonth',
    meta: { tag: '客服月统计' },
    component: () => import('@/pages/statistics/UserMonthPage')
  },
  {
    path: '/statistics/express-in-log',
    name: 'ExpressInLog',
    meta: { tag: '快递单接收统计' },
    component: () => import('@/pages/statistics/ExpressInLogPage')
  },
  {
    path: '/statistics/pmp-record-efficiency',
    name: 'PmpRecordEfficiency',
    meta: { tag: '工单时效统计' },
    component: () => import('@/pages/statistics/PmpRecordEfficiencyPage')
  },
  {
    path: '/pmp-record-evaluate/index',
    name: 'pmpRecordEvaluatePage',
    meta: { tag: '满意度调查管理' },
    component: () => import('@/pages/PmpRecordEvaluate')
  },
  {
    path: '/statistics/pay-rate',
    name: 'PayRate',
    meta: { tag: '报价成功率统计' },
    component: () => import('@/pages/statistics/PayRatePage')
  },
  {
    path: '/statistics/pmp-record-evaluate',
    name: 'PmpRecordEvaluate',
    meta: { tag: '满意度调查统计' },
    component: () => import('@/pages/statistics/PmpRecordEvaluatePage')
  },
  {
    path: '/statistics-record/index',
    name: 'statisticsRecordIndexPage',
    meta: { tag: '月统计汇总' },
    component: () => import('@/pages/statisticsRecordPage/index')
  },
  {
    path: '/statistics/repeat-repair',
    name: 'RepeatRepairPage',
    meta: { tag: '重复维修率统计' },
    component: () => import('@/pages/statistics/RepeatRepairPage')
  },
  {
    path: '/warning-user-record/index',
    name: 'WarningUserRecordPage',
    meta: { tag: '风险客户' },
    component: () => import('@/pages/WarningUserRecordPage')
  }
]
